import React from "react";
const CreateSlot = () => {
  return <h5>hello create the slot</h5>;
};
export default CreateSlot;
